<template>
  <div class="firstExamineResult">
    <van-popup v-model="showDialog" :close-on-click-overlay="false">
      <div class="content">
        <div class="header">
          <img v-if="code === 70418 || code === 70419" src="../../../assets/images/attestation/first-fail-back.png" alt="" srcset="">
          <img v-else-if="code === 70417" src="../../../assets/images/attestation/first-many-times.png" alt="" srcset="">
          <img v-else src="../../../assets/images/attestation/already-back.png" alt="" srcset="">
        </div>
        <div class="bottom">
          <div class="message" v-html="message"></div>
          <div v-if="code === 70418 || code === 70419" class="careful">注：您也可以上传行驶证认证</div>
          <div class="btn-box flex" v-if="code === 70418 || code === 70419 || code === 70417">
            <div class="btn cancle-btn" @click="cancleBtn">{{ cancleBtnText }}</div>
            <div class="btn define-btn" @click="defineBtn">{{ defineBtnText }}</div>
          </div>
          <div class="btn-box flex" v-else>
            <div class="tip-define-btn" @click="tipDefineBtn">确定</div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { filterCodeMessage } from '../../../utils/attestation'
export default {
  props: {
    code: {
      type: Number,
      default () {
        return 70419
      },
      errorMessage: {
        type: String,
        default () {
          return ''
        }
      },
    }
  },
  data() {
    return {
      showDialog: false
    };
  },
  computed: {
    message() {
      return filterCodeMessage(this.code) || this.errorMessage
    },

    cancleBtnText() {
      let value = ''
      if (this.code === 70419 || this.code === 70418) {
        value = '上传证件'
      } else {
        value = '取消上传'
      }
      return value
    },

    defineBtnText() {
      let value = ''
      if (this.code === 70419 || this.code === 70418) {
        value = '重新填写'
      } else {
        value = '上传证件'
      }
      return value
    }
  },
  components: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    /**
     *
     * 显示弹框
    */
    showPopup() {
      this.showDialog = true
    },

    /**
     *
     *
     * 取消事件
    */
    cancleBtn() {
      this.showDialog = false
      this.$emit('cancel')
    },

    /**
     *
     *
     * 确定事件
    */
    defineBtn() {
      this.showDialog = false
      this.$emit('define')
    },

    /**
     *
     *
     * 提示框确定事件
    */
    tipDefineBtn() {
      this.showDialog = false
      this.$emit('tipdefine')
    },
  }
};
</script>

<style scoped lang="scss">
.firstExamineResult>:first-child {
  background-color: rgba(0,0,0,.4)
}
.firstExamineResult>:nth-child(2){
  width: 80%;
  border-radius: 18px;
  top: 40%;
}
.firstExamineResult {
  .content {
    .header {
      img {
        width: 100%;
      }
    }
    .bottom {
      padding: 20px 40px 30px;
      background-color: #ffffff;
      text-align: center;
      .message {
        color: #656565;
        font-size: 24px;
        line-height: 50px;
      }
      .careful {
        color: #5572FC;
        font-size: 18px;
        padding-top: 30px;
      }
      .btn-box {
        justify-content: space-between;
        margin-top: 30px;
        .btn {
          flex: .4;
          height: 80px;
          font-size: 24px;
          line-height: 80px;
          text-align: center;
          border-radius: 4px;
        }
        .cancle-btn {
          border: 1px solid #5572FC;
          color: #5572FC;
        }
        .define-btn {
          background-color: #5572FC;
          color: #ffffff;
        }
        .tip-define-btn {
          flex: 1;
          background-color: #5572FC;
          border-radius: 4px;
          text-align: center;
          color: #ffffff;
          line-height: 80px;
          height: 80px;
          margin: 0 20px;
        }
      }
    }
  }
}
</style>
